import { Pipe, PipeTransform } from '@angular/core';
import { Company } from '../interfaces/company.interface';
import { getAssistantPromptByTag } from '../utils/assistant-prompt.util';

@Pipe({
  name: 'getAssistantPrompt'
})
export class GetAssistantPromptPipe implements PipeTransform {

  /**
   * Transforms a company and a tag into the content of the assistant prompt.
   *
   * @param company The company object containing assistant prompts.
   * @param tag The unique tag identifying the assistant prompt.
   *
   * @author Sabin Nițu
   * @returns The content of the assistant prompt if found, or an empty string.
   */
  transform(company: Company, tag: string): string {
    return getAssistantPromptByTag(company, tag);
  }

}
